import map from '../map'
import Select from 'ol/interaction/Select';
import Toggle from 'ol-ext/control/Toggle';
import Overlay from 'ol-ext/control/Overlay';
import {get_species} from '../tele_funcs';


	// Control Select 
	var select = new Select({});
	map.addInteraction(select);
	// On selected => show/hide popup
	select.getFeatures().on('add', function(e)
	{	var feature = e.element;

	    let layer = select.getLayer(feature);
	    console.log('layer',layer); // here you have the selected layer
	    console.log('ptt',layer.get("ptt")); // here you have the selected layer
	    console.log('layerSource',layer.getSource()); // here you have the selected layer
		console.log('feature',feature);
		console.log(e.coordinate);
		var img = $("<img>").attr("src", feature.get("img"));
		var info = $("<div>").append( $("<p>").text(feature.get("color")));
		var info2 = $("<div>").append( $("<p>").text("Date/time: "+feature.get("location_date")));
		var title = $("<div>").append( $("<p>").text("Name: "+layer.get("title")));
		var ptt = $("<div>").append( $("<p>").text("Code: "+layer.get("ptt")));

		console.log(feature.getProperties());
		var content = $("<div class='sppdetails'>")
				.append("<div><b>Details of fix")
		//		.append( img )
		//		.append(info)
				.append(info2)
				.append(ptt)
				.append(title)
		$(".data").html(content);
		window.menu.show();
	});
	select.getFeatures().on('remove', function(e)
	{	$(".data").html("");
	});
